import { useAtomValue, useSetAtom } from 'jotai';
import { showContactSellerModalAtom } from '../../constants';

export const useContactSellerModal = () => useAtomValue(showContactSellerModalAtom);

export const useContactSellerModalUpdater = () => useSetAtom(showContactSellerModalAtom);
